<script lang="ts" setup>
import { computed } from "vue";
import { ChevronDown, ChevronLeft, ChevronRight } from "@lucide/vue";

const emits = defineEmits(["onToggle"]);

const props = defineProps<{
  isActive: boolean;
  name: string;
  direction?: string;
}>();

const chevron = computed(() => {
  if (!props.isActive) return ChevronDown;
  return props.direction === "right" ? ChevronRight : ChevronLeft;
});
</script>

<template>
  <button
    :id="`ignore-click-${name}`"
    type="button"
    :aria-expanded="isActive"
    class="ignore-filter-icon-click t-small text-type-default focus-ring rounded-4 hover:bg-app-blue-200/20 flex w-full cursor-pointer items-center justify-between space-x-3 px-3 py-2 whitespace-nowrap transition-colors select-none"
    :class="[direction === 'right' ? 'flex-row-reverse' : 'flex-row']"
    @click="emits('onToggle', name)">
    <component
      :is="chevron"
      class="ignore-filter-icon-click icon-sm text-type-muted pointer-events-none shrink-0"
      :stroke-width="1.5" />
    <span class="pointer-events-none first-letter:uppercase">{{ name }}</span>
  </button>
</template>
